// extracted by mini-css-extract-plugin
module.exports = {"senderButton":"AddSenderButton_senderButton__3zYl9","senderButtonLock":"AddSenderButton_senderButtonLock__3gK7C","senderButtonWrapper":"AddSenderButton_senderButtonWrapper__1Zcy8"};